export function getAnimationProps<T extends Record<string, any>>(
  animation: keyof T,
  animationList: T
) {
  return { ...animationList[animation] };
}
